import {UPDATE_SOCIETIES, UPDATE_ROLES, UPDATE_SERVER_STATUS} from '../types'

const iState = {
  isOnline: true,
  societies: [],
  roles: [],
}

const Configs = (state = iState, action) => {
  switch (action.type) {
    case UPDATE_SOCIETIES: {
      return {...state, societies: action.payload}
    }

    case UPDATE_ROLES: {
      return {...state, roles: action.payload}
    }

    case UPDATE_SERVER_STATUS: {
      return {...state, isOnline: action.payload}
    }

    default: {
      return state
    }
  }
}

export default Configs
